import React, { Component } from "react";
import { useState, useRef } from "react";
import MaterialTable from "@material-table/core";
import * as APIModels from "../../models";
import moment from "moment";
import { FileService } from "../../services/SubmissionService";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import AttorneySelect from "../../components/shared/AttorneySelect";
import Select, { ActionMeta } from "react-select";
import { ReportService } from "../../services/SubmissionService";
import Footer from "../../components/shared/Footer";

dayjs.extend(utc);
dayjs.extend(timezone);

type NameValueOptionType = { label: string; value: string };

export default function Status() {
    const [searching, setSearching] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const initialToDate = moment(Date.now()).toDate();
    const initialFromDate = moment(Date.now()).add(-1, "days").toDate();

    const [fromDateTime, setFromDateTime] = useState<Date>(initialFromDate);
    const [toDateTime, setToDateTime] = useState<Date>(initialToDate);

    const [statusFromDateTime, setStatusFromDateTime] =
        useState<Date>(initialFromDate);
    const [statustoDateTime, setStatusToDateTime] =
        useState<Date>(initialToDate);

    const [reportRequest, setReportRequest] =
        useState<APIModels.FilingStatusReportRequest>({});

    const [attorneyId, setAttorneyId] = useState("");
    const [firmId, setFirmId] = useState("");

    const [data, setData] = useState([] as APIModels.SubmissionFiling[]);

    const searchByNameValues: NameValueOptionType[] = [
        {
            label: "All",
            value: "All",
        },
        {
            label: "Pending",
            value: "Pending",
        },
        {
            label: "Accepted",
            value: "Accepted",
        },
        {
            label: "Rejected",
            value: "Rejected",
        },
    ];
    const [searchById, setSearchById] = useState("0");
    const [searchByOptions, setSearchByOptions] = useState(searchByNameValues);

    const tableRef = useRef<MaterialTable<APIModels.SubmissionFiling>>();
    /*
    useEffect(() => {
        const toDateTimeISO = toDateTime.toISOString();
        const fromDateTimeISO = fromDateTime.toISOString();

        if (toDateTimeISO !== reportRequest.toDate) {
            setReportRequest(
                (prevReportRequest) =>
                    ({
                        ...prevReportRequest,
                        toDate: toDateTimeISO,
                    } as APIModels.EFileReportRequest)
            );
        }
        if (fromDateTimeISO !== reportRequest.fromDate) {
            setReportRequest(
                (prevReportRequest) =>
                    ({
                        ...prevReportRequest,
                        fromDate: fromDateTimeISO,
                    } as APIModels.EFileReportRequest)
            );
        }
    }, [toDateTime, fromDateTime]);
*/
    /*
    const onSearchByOptionChange = (
        value: NameValueOptionType | null,
        actionMeta: ActionMeta<NameValueOptionType>
    ) => {
        setSearchById(value!.value);
        if (value!.value === "0") {
            setReportRequest({
                ...reportRequest,
                searchBy: parseInt(value!.value),
                contains: "",
            });
        } else {
            setReportRequest({
                ...reportRequest,
                searchBy: parseInt(value!.value),
            });
        }
    };
*/
    const downloadFile = (submissionId: string, filename: string) => {
        FileService.get({
            submissionId: submissionId,
            documentId: filename,
            source: "",
        }).then(
            (resp) => {
                resp.json().then((json) => {
                    const anchor = document.createElement("a");
                    anchor.href = json.url;
                    anchor.target = "blank";
                    anchor.download = filename!;
                    anchor.click();
                });
            },
            (error) => {
                console.log(error);
            }
        );
    };

    const onAttorneySelected = (id: string, name: string) => {
        setAttorneyId(id);
    };

    const onFirmSelected = (id: string, name: string) => {
        setFirmId(id);
    };

    const onSearchClick = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        tableRef.current!.onQueryChange({
            pageSize: tableRef.current?.props.options?.pageSize,
            page: 0,
        });
        // setSearching(true);
        //   setErrorMessage("");
        //  ReportService.filingStatus({
        //       attorneyId: attorneyId,
        //       body: reportRequest,
        //    }).then(
        //        (resp) => {
        //           setSearching(false);
        //            setData(resp.data as APIModels.SubmissionFiling[]);
        //       },
        //        (error) => {
        //            setSearching(false);
        //           setErrorMessage("An error has occurred");
        //         }
        //     );
    };

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">Reporting</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            Reporting
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Filing Status
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                <form action="#" onSubmit={onSearchClick}>
                    <div className="mb-3">
                        <AttorneySelect
                            onFirmSelected={onFirmSelected}
                            onAttorneySelected={onAttorneySelected}
                        />
                    </div>
                    <div className="row mb-3">
                        <div className="col-6 ">
                            <label htmlFor="txtFrom" className="form-label">
                                Submitted Since:
                            </label>
                            <div className="input-group">
                                <input
                                    type="date"
                                    className="form-control"
                                    //      required
                                    aria-describedby="inputGroupPrepend"
                                    value={
                                        reportRequest.submittedSince &&
                                        reportRequest.submittedSince
                                            .toISOString()
                                            .substring(0, 10)
                                    }
                                    onChange={(event) =>
                                        setReportRequest({
                                            ...reportRequest,
                                            submittedSince:
                                                event?.currentTarget
                                                    ?.valueAsDate ?? undefined,
                                        })
                                    }
                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <label htmlFor="txtTo" className="form-label">
                                Submitted Till:
                            </label>
                            <div className="input-group">
                                <input
                                    type="date"
                                    className="form-control"
                                    //        required={true}
                                    aria-describedby="inputGroupPrepend"
                                    value={
                                        reportRequest.submittedUntil &&
                                        reportRequest.submittedUntil
                                            .toISOString()
                                            .substring(0, 10)
                                    }
                                    onChange={(event) =>
                                        setReportRequest({
                                            ...reportRequest,
                                            submittedUntil:
                                                event?.currentTarget
                                                    ?.valueAsDate ?? undefined,
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <label
                                htmlFor="selectSeachBy"
                                className="form-label"
                            >
                                Status:
                            </label>

                            <Select
                                id="selectSeachBy"
                                name="selectSeachBy"
                                styles={{
                                    // Fixes the overlapping problem of the component
                                    menu: (provided) => ({
                                        ...provided,
                                        zIndex: 9999,
                                    }),
                                }}
                                value={searchByOptions.filter(
                                    (c) => c.value === reportRequest.status
                                )}
                                options={searchByOptions}
                                onChange={(event) =>
                                    setReportRequest({
                                        ...reportRequest,
                                        status: event?.value,
                                    })
                                }
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-6 ">
                            <label htmlFor="txtFrom" className="form-label">
                                Accepted/Rejected Since:
                            </label>
                            <div className="input-group">
                                <input
                                    type="date"
                                    className="form-control"
                                    //  id="txtFrom"
                                    //          required
                                    aria-describedby="inputGroupPrepend"
                                    value={
                                        reportRequest.statusUpdatedSince &&
                                        reportRequest.statusUpdatedSince
                                            .toISOString()
                                            .substring(0, 10)
                                    }
                                    onChange={(event) => {
                                        setReportRequest({
                                            ...reportRequest,
                                            statusUpdatedSince:
                                                event?.currentTarget
                                                    ?.valueAsDate ?? undefined,
                                        });
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <label htmlFor="txtTo" className="form-label">
                                Accepted/Rejected Till:
                            </label>
                            <div className="input-group">
                                <input
                                    type="date"
                                    className="form-control"
                                    //         required={true}
                                    aria-describedby="inputGroupPrepend"
                                    value={
                                        reportRequest.statusUpdatedUntil &&
                                        reportRequest.statusUpdatedUntil
                                            .toISOString()
                                            .substring(0, 10)
                                    }
                                    onChange={(event) =>
                                        setReportRequest({
                                            ...reportRequest,
                                            statusUpdatedUntil:
                                                event?.currentTarget
                                                    ?.valueAsDate ?? undefined,
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="text-end mb-3">
                            {searching ? (
                                <button
                                    className="btn btn-primary waves-effect waves-light mt-2"
                                    type="button"
                                    disabled={true}
                                >
                                    <span
                                        className="spinner-border spinner-border-sm me-1"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                    Searching...
                                </button>
                            ) : (
                                <button
                                    className="btn btn-primary waves-effect waves-light mt-2"
                                    type="submit"
                                    // onClick={onSearchClick}
                                >
                                    Search
                                </button>
                            )}
                            <div style={{ color: "red" }}>{errorMessage}</div>
                        </div>
                    </div>
                </form>

                <div className="row">
                    <div className="col-12">
                        <div style={{ maxWidth: "100%" }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <MaterialTable
                                    tableRef={tableRef}
                                    data={(query) =>
                                        new Promise((resolve, reject) => {
                                            ReportService.filingStatus({
                                                attorneyId: attorneyId,
                                                perPage: query.pageSize,
                                                page: query.page + 1,
                                                body: reportRequest,
                                            })
                                                .then((response) => response)
                                                .then((result) => {
                                                    resolve({
                                                        data: result.data ?? [],
                                                        page:
                                                            (result.currentPage ??
                                                                1) - 1,
                                                        totalCount:
                                                            result.totalCount ??
                                                            0,
                                                    });
                                                });
                                        })
                                    }
                                    columns={[
                                        {
                                            title: "Matter",
                                            field: "matterNumber",
                                        },
                                        {
                                            title: "Court",
                                            field: "court",
                                        },
                                        {
                                            title: "Case Number",
                                            field: "caseNumber",
                                        },
                                        {
                                            title: "Case Style",
                                            field: "caseTitle",
                                            cellStyle: {
                                                whiteSpace: "nowrap",
                                                textAlign: "center",
                                            },
                                        },
                                        {
                                            title: "FiledDateTime",
                                            field: "Submitted Date",
                                            type: "datetime",
                                            dateSetting: {
                                                format: "DD/MM/yyyy HH:MM:ss",
                                            },
                                            exportTransformer: (
                                                row: APIModels.SubmissionFiling
                                            ) =>
                                                dayjs(row.statusUpdatedDate)
                                                    .tz("America/New_York") // Set the timezone to New York
                                                    .format(
                                                        "YYYY-MM-DD HH:mm:ss"
                                                    ), // Format the output to your desired format
                                        },
                                        {
                                            title: "Reference/Envelope Number",
                                            field: "referenceNumber",
                                        },
                                        {
                                            title: "Status",
                                            field: "status",
                                        },
                                        {
                                            title: "Accepted/Rejected Date",
                                            field: "statusUpdatedDate",
                                            type: "datetime",
                                            dateSetting: {
                                                format: "DD/MM/yyyy HH:MM:ss",
                                            },
                                            exportTransformer: (
                                                row: APIModels.SubmissionFiling
                                            ) =>
                                                dayjs(row.statusUpdatedDate)
                                                    .tz("America/New_York") // Set the timezone to New York
                                                    .format(
                                                        "YYYY-MM-DD HH:mm:ss"
                                                    ), // Format the output to your desired format
                                        },
                                        {
                                            title: "Files",
                                            field: "filename",
                                            render: (rowData) => (
                                                <>
                                                    <a
                                                        style={{
                                                            cursor: "pointer",
                                                            color: "#526dee",
                                                        }}
                                                        onClick={() =>
                                                            downloadFile(
                                                                rowData.submissionID ??
                                                                    rowData.id ??
                                                                    "",
                                                                rowData.filename ??
                                                                    ""
                                                            )
                                                        }
                                                    >
                                                        Original
                                                    </a>
                                                    <br />
                                                    {rowData.stampedCopyID &&
                                                        rowData.stampedCopyID !=
                                                            null && (
                                                            <a
                                                                style={{
                                                                    cursor: "pointer",
                                                                    color: "#526dee",
                                                                }}
                                                                onClick={() =>
                                                                    downloadFile(
                                                                        rowData.submissionID ??
                                                                            rowData.id ??
                                                                            "",
                                                                        "STAMPED-" +
                                                                            rowData.filename
                                                                    )
                                                                }
                                                            >
                                                                Stamped Copy
                                                            </a>
                                                        )}
                                                </>
                                            ),
                                        },
                                        {
                                            title: "Status Reason",
                                            field: "statusUpdatedReason",
                                        },
                                    ]}
                                    parentChildData={(row, rows) =>
                                        rows.find(
                                            (a) =>
                                                a.id === row.submissionID &&
                                                !a.submissionID
                                        )
                                    }
                                    title="Filing Status Report"
                                    options={{
                                        search: false,
                                        pageSize: 50,
                                        pageSizeOptions: [50],
                                        maxBodyHeight: "500px",
                                    }}
                                />
                            </LocalizationProvider>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
